<template>
  <div>
    <b-overlay
      v-if="
        selected_report?.report_code !== current_report_code &&
        selected_report?.report_url !== current_report_code
      "
      show
      no-wrap
    />

    <template v-else>
      <StoryBoardViewer v-if="selected_report?.story_board" />
      <StandardIndex v-else />
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import StoryBoardViewer from '../story_board/StoryBoardViewer';
import StandardIndex from './StandardIndex';
import ChannelService from '@/components/ChannelService';
import { read_mixin } from '@/mixins/read_mixin';

export default {
  name: 'FullView2021',
  mixins: [read_mixin],
  props: {},
  computed: {
    ...mapGetters('report_list', ['selected_report', 'view_mode', 'current_report_code']),
    isSvg() {
      return this.img_src && this.img_src.toLowerCase().endsWith('.svg');
    }
  },
  components: {
    StoryBoardViewer,
    StandardIndex
  },
  data() {
    return {
      img_src: '',
      qesg_image_modal: false,
      originalFontSize: ''
    };
  },
  beforeRouteEnter(to, from, next) {
    if (to.path.includes('/report_preview') && !from.name) {
      const navigationType = performance.getEntriesByType('navigation')[0].type;

      if (
        navigationType !== 'reload' &&
        (document.referrer === '' || document.referrer.indexOf(window.location.origin) !== 0)
      ) {
        window.alert('URL을 통한 페이지 접근은 제한됩니다.');
        window.location.href = 'https://report.qesg.co.kr/';
      } else {
        next();
      }
    } else {
      next();
    }
  },

  watch: {
    'selected_report.font_size'(newSize) {
      if (newSize !== undefined && newSize !== null) {
        document.documentElement.style.fontSize = `${newSize}px`;
      }
    }
  },
  mounted() {
    if (!process.env.VUE_APP_REPORT_CODE) {
      ChannelService.hideChannelButton();
    }
    this.originalFontSize =
      document.documentElement.style.fontSize ||
      window.getComputedStyle(document.documentElement).fontSize;
    if (
      this.selected_report &&
      this.selected_report.font_size !== undefined &&
      this.selected_report.font_size !== null
    ) {
      document.documentElement.style.fontSize = `${this.selected_report.font_size}px`;
    }
  },
  beforeDestroy() {
    document.documentElement.style.fontSize = this.originalFontSize;
    ChannelService.boot();
    this.$store.commit('report_list/change_lang', 'KOR');
  },
  created() {
    if (this.$route.query?.l == 'ENG') {
      this.$store.commit('report_list/change_lang', 'ENG');
    } else {
      this.$store.commit('report_list/change_lang', 'KOR');
    }
  },
  methods: {}
};
</script>

<style></style>
